'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["connectDragSource", "disabled", "didDrop", "dropItem", "disabledMessage"];
import I18n from 'I18n';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { LAYOUT } from 'LayoutBuilderUI/lib/DragDropConstants';
import { LAYOUTS, LAYOUT_COLUMNS } from 'EmailEditorUI/constants/SectionLayoutConstants';
import { DragSource } from 'react-dnd-compat';
import DraggableTile from './DraggableTile';
import ColumnLayoutIcon from 'ContentEditorUI/components/shared/ColumnLayoutIcon';
import { logInteraction } from 'LayoutBuilderUI/actions/ApiActions';
import { getLayoutLoggingType } from 'EmailEditorUI/utils/usageTracking';
import { dragLayoutTile } from 'LayoutBuilderUI/actions/layoutActions';
import { dropLayoutOnSection, addNewLayoutBeforeFooter } from 'EmailEditorUI/redux/actions/LayoutActions';
import { jsx as _jsx } from "react/jsx-runtime";
const layoutDragSource = {
  beginDrag(props, monitor, component) {
    props.dispatch(dragLayoutTile());
    return {
      key: props.layout,
      layoutSpec: LAYOUT_COLUMNS[props.layout],
      component,
      shouldUsePreview: false
    };
  },
  endDrag(props, monitor) {
    if (!monitor.didDrop()) {
      return;
    }
    const dropResult = monitor.getDropResult();
    const item = monitor.getItem();
    logInteraction({
      action: 'Modify Layout Action',
      event: 'add-section',
      'section-layout': getLayoutLoggingType(props.layout)
    });
    props.dispatch(dropLayoutOnSection({
      layoutSpec: item.layoutSpec,
      dropPosition: dropResult.dropPosition,
      forceDropOutsideBoxed: dropResult.forceDropOutsideBoxed,
      targetSectionIndex: dropResult.sectionIndex
    }));
  }
};
class LayoutTile extends Component {
  constructor(props) {
    super(props);
    this.onDoubleClick = this.onDoubleClick.bind(this);
  }
  onDoubleClick() {
    if (this.props.disabled) return;
    logInteraction({
      action: 'Modify Layout Action',
      event: 'add-section-double-click',
      'section-layout': getLayoutLoggingType(this.props.layout)
    });
    this.props.dispatch(addNewLayoutBeforeFooter({
      layoutSpec: LAYOUT_COLUMNS[this.props.layout]
    }));
  }
  getLabel() {
    const {
      layout
    } = this.props;
    return I18n.text(`layoutBuilder.columnLayouts.labels.${layout}`);
  }
  renderIcon() {
    const {
      layout
    } = this.props;
    const columnWidths = LAYOUT_COLUMNS[layout];
    if (!Array.isArray(columnWidths)) {
      console.error(`Unexpected layout passed to LayoutTile: ${layout}`);
      return null;
    }
    return /*#__PURE__*/_jsx(ColumnLayoutIcon, {
      columnWidths: columnWidths
    });
  }
  render() {
    const _this$props = this.props,
      {
        connectDragSource,
        disabled,
        didDrop,
        dropItem,
        disabledMessage
      } = _this$props,
      otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const didDropThis = didDrop && dropItem.key === this.props.layout;
    return /*#__PURE__*/_jsx(DraggableTile, Object.assign({
      "data-test-id": "layout-tile",
      disabled: disabled,
      disabledMessage: disabledMessage,
      icon: this.renderIcon(),
      label: this.getLabel(),
      didDrop: didDropThis,
      onDoubleClick: this.onDoubleClick,
      innerRef: el => {
        if (!disabled) {
          connectDragSource(el);
        }
      }
    }, otherProps));
  }
}
LayoutTile.propTypes = {
  layout: PropTypes.oneOf(Object.keys(LAYOUTS)).isRequired,
  disabled: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  // react-dnd
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  didDrop: PropTypes.bool.isRequired,
  dropItem: PropTypes.object,
  disabledMessage: PropTypes.element
};
export default DragSource(LAYOUT, layoutDragSource, monitor => ({
  didDrop: monitor.didDrop(),
  dropItem: monitor.getItem()
}))(LayoutTile);